import { useMemo } from 'react';
import { getClientLogoDomain } from '@/utils/clientLogo';
import { useListContactsQuery } from '@/features/contacts/contactsApi';

export const useGetClientContactData = ({ clientRow, clientId }) => {
	const { currentData: contacts } = useListContactsQuery(clientId, {
		skip: !clientId,
		selectFromResult: ({ currentData, ...rest }) => {
			const contacts = currentData ?? [];
			return {
				...rest,
				currentData: contacts,
			};
		},
	});

	const mainContact = useMemo(() => contacts?.find((c) => c.isMainContact), [contacts]);

	const subtitle = useMemo(
		() => mainContact?.Name ?? mainContact?.Addressee ?? 'Unknown',
		[mainContact?.Name, mainContact?.Addressee],
	);

	const contactEmail = useMemo(() => mainContact?.Email ?? null, [mainContact?.Email]);

	const contactPhone = useMemo(
		() => mainContact?.Mobile ?? mainContact?.Telephone ?? null,
		[mainContact?.Mobile, mainContact?.Telephone],
	);

	const logoDomain = useMemo(
		() =>
			getClientLogoDomain({
				mainContact,
				clientRow,
			}),
		[
			mainContact?.Email,
			mainContact?.email,
			mainContact?.contactEmail,
			clientRow?.contactEmail,
			clientRow?.website,
		],
	);

	return { logoDomain, mainContact, subtitle, contactEmail, contactPhone };
};
